import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { appRoutes } from './app.routes';
import { EnvironmentResolver } from './core/environment-resolver';
import { DealerServiceToken, initializeDealerService } from './factories/dealer.factory';
import { WsClientService } from './services/ws-client.service';

const initializeEnvironment = (environmentResolver: EnvironmentResolver) => async (): Promise<void> => {
    await environmentResolver.setEnvironment();
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes),
        provideAnimations(),
        provideHttpClient(),
        provideAppInitializer(async () => {
            const initializerFn = initializeEnvironment(inject(EnvironmentResolver));
            return initializerFn();
        }),
        {
            provide: DealerServiceToken,
            useFactory: initializeDealerService,
            deps: [WsClientService]
        }
    ]
};
